import ChartsService from '@/services/benchmarks/ChartsService.js';
import { getBenchmarkId, SERIES_BY_MEDIA, chartLegendOrder } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';
export async function fetchPublicationsOverTimeWithDistribution({ commit, rootState, rootGetters, state }, { datePortion, groupSelected }) {
  try {
    commit(chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_LOADING, true);
    commit(chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_ERROR, false);

    function getDefaultGroupId() {
      const hasGroupInGroupList = rootState.ui.groupList
        .find(group => group.id === state.publicationsOverTimeWithDistribution.groupSelected)?.id;

      if (groupSelected) return groupSelected;

      if (hasGroupInGroupList) return hasGroupInGroupList;

      return rootState.ui.groupList[0].id;
    }

    const periodLabel = rootGetters['ui/getPublicationsOverTimeWithDistributionPeriod'].label;
    const period = datePortion ?? periodLabel;
    const channelSelected = rootState.ui.channel;
    const defaultGroupId = getDefaultGroupId();

    const { series, categories } = await ChartsService.getPublicationsOverTimeWithDistribution({
      'benchmark-id': getBenchmarkId(),
      'group-id': defaultGroupId,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: channelSelected,
      'date-portion': period,
    });

    if (!Array.isArray(series)) throw new Error();

    const [publications, interactions] = series;

    const publicationsSeriesFormatted = {
      ...publications,
      type: 'spline',
      color: '#000',
      lineWidth: 2,
      zIndex: 1,
      index: 3,
      marker: {
        radius: 4,
      },
    };

    const interactionsSeriesFormatted = Object.keys(interactions.data).map((name) => ({
      name,
      data: interactions.data[name],
      type: 'column',
      yAxis: 1,
      color: SERIES_BY_MEDIA[channelSelected.toLowerCase()][name.toLowerCase()]?.color,
      index: chartLegendOrder.publicationsOverTimeWithDistribution[name],
    }));

    const interactionsSeriesByChannel = channelSelected.toLowerCase() === 'youtube' || channelSelected.toLowerCase() === 'instagram'
      ? interactionsSeriesFormatted.filter((item) => item.name !== 'Compartilhamento')
      : interactionsSeriesFormatted;

    const payload = {
      series: [
        publicationsSeriesFormatted,
        ...interactionsSeriesByChannel,
      ],
      categories,
    };

    commit(chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_DATA, payload);
  } catch (e) {
    commit(chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_LOADING, false);
  }
}
